__turbopack_context__.v({
  "badge": "holding-type-badges-module-scss-module___SyclW__badge",
  "badges": "holding-type-badges-module-scss-module___SyclW__badges",
  "modal": "holding-type-badges-module-scss-module___SyclW__modal",
  "small": "holding-type-badges-module-scss-module___SyclW__small",
  "title": "holding-type-badges-module-scss-module___SyclW__title",
});
